module.exports = "mutation ($data: FormInput!) {\n  FormCreate(data: $data) {\n    id\n  }\n}\n"